import React from "react";
import Title from "../typography/Title";
import TitleTag from "../typography/TitleTag";
import Keyword from "../typography/Keyword";
import Section from "../layout/Section";
import { Pattern } from "../Pattern";
import { TitleHeading } from "../typography/TitleHeading";
import BodyText from "../typography/BodyText";
import { useAnimation } from "../../hooks/useAnimate";

interface FeaturesGrid2Props {
  tag: string;
  title: string;
  description?: string | React.ReactNode;
  elements: string[];
  theme?: "dark" | "white" | "gray";
}

export const FeaturesGrid2: React.FunctionComponent<FeaturesGrid2Props> = ({
  tag,
  title,
  description,
  elements,
  theme,
}) => {
  const { id, animate } = useAnimation();

  return (
    <Section theme={theme} id={id}>
      <div className="flex flex-wrap lg:px-7 justify-between">
        <div {...animate("fade-right")} className="w-full mb-8 lg:w-4/12">
          <TitleHeading theme={theme} tag={tag} title={title} />
          {description && (
            <BodyText justify={false} className="max-w-3xl mx-auto mt-4">
              {description}
            </BodyText>
          )}
        </div>
        <div className="w-full lg:w-7/12 grid md:grid-cols-2 gap-6 xl:gap-14">
          {elements.map((el, i) => (
            <div {...animate("fade-left", 50 * i)}>
              <p
                key={i}
                className={`${theme === "dark" ? "text-white" : "text-gray-900 dark:text-gray-100"} text-lg`}
                dangerouslySetInnerHTML={{
                  __html: el,
                }}
              />
              <hr
                className={`w-2/12 my-2 border-primary border-2 rounded-3xl`}
              />
            </div>
          ))}
        </div>
      </div>
      <Pattern
        type="square"
        className={`hidden lg:block absolute h-3/6 w-1/12 -bottom-12 left-0 ${
          theme === "dark"
            ? "text-gray-800"
            : "text-gray-200 dark:text-gray-800 opacity-70"
        } opacity-60`}
      ></Pattern>
    </Section>
  );
};
